module.exports = __webpack_public_path__ + "static/media/DFA0FE49-A774-4626-9086-33C64FF02B64-removebg-preview.bbef371f.png";